import { API_ENDPOINT } from '@/constant/constant.ts'
import { useLoginStore } from '@/store/LoginStore.ts'

export interface IChangePassword {
    currentPassword: string;
    newPassword: string;
}

export const apiChangePassword = async (params: IChangePassword) => {
    const accessToken = useLoginStore.getState().accessToken
    const endpoint = `${API_ENDPOINT}/auth/me/password`

    const response = await fetch(endpoint, {
        method: 'PATCH',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            ...(accessToken && { 'Authorization': `Bearer ${accessToken}` }),
        },
        body: JSON.stringify(params),
        credentials: 'include',
    })

    const res = await response.json()
    return {
        code: res.code ?? res.statusCode,
        message: res.message as string,
    }
}
